<template>
  <div style="display: inline" class="ledger-settings-wrap">
    <span class="pull-right">
      <a style="cursor: pointer" @click="showLedgerSettings"><i class="pe pe-cogs" aria-hidden="true"/></a>
    </span>
    <b-modal
      id="ledgerSettings"
      ref="ledgerSettings"
      :key="'ledgerSettingsModal' + ledgerId"
      hide-footer
      title="Ledger settings"
      no-fade
      @hidden="hideLedgerSettings"
    >
      <b-tabs>
        <b-tab title="Details" active>
          <br>
          <div class="row">
            <div class="col-md-6 offset-md-4">
              <div v-if="error.details" class="alert alert-danger">{{ error.details }}</div>
              <div v-if="message.details" class="alert alert-success">{{ message.details }}</div>
            </div>
          </div>
          <div class="form-group row">
            <label for="name" class="col-md-4 col-form-label text-md-right">Name</label>

            <div class="col-md-6">
              <input id="name" v-model="form.details.name" :class="{ 'is-invalid': errors.details.name }" type="text" class="form-control">
              <span v-if="errors.details.name" class="invalid-feedback">
                <div v-for="(error, index) in errors.details.name" :key="index"><strong>{{ error }}</strong></div>
              </span>
            </div>
          </div>

          <div class="form-group row">
            <label for="name" class="col-md-4 col-form-label text-md-right">Currency</label>

            <div class="col-md-6">
              <input id="currency" v-model="form.details.currency" :class="{ 'is-invalid': errors.details.currency }" type="text" class="form-control">
              <span v-if="errors.details.currency" class="invalid-feedback">
                <div v-for="(error, index) in errors.details.currency" :key="index"><strong>{{ error }}</strong></div>
              </span>
            </div>
          </div>

          <div class="form-group text-md-center row">
            <div class="col-12 ledgerShowOnDashboard">
              <b-form-checkbox id="ledgerShowOnDashboard"
                               v-model="form.details.show_statistics_on_dashboard"
                               :value="true"
                               :unchecked-value="false">
                Show the statistics on the dashboard
              </b-form-checkbox>
            </div>
          </div>

          <div class="form-group row mb-0">
            <div class="col-md-6 offset-md-4 text-center">
              <button type="submit" class="btn btn-primary" @click.prevent="submitDetails()">
                <span v-if="this.$loading.isLoading('ledger-updating')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Save
              </button>
            </div>
          </div>
          <hr>
        </b-tab>
        <b-tab title="Sharing" >
          <br>
          <div class="row">
            <div class="col-8">
              <div v-if="error.sharingWith" class="alert alert-danger">{{ error.sharingWith }}</div>
              <div v-if="message.sharingWith" class="alert alert-success">{{ message.sharingWith }}</div>
            </div>
          </div>
          <div class="form-group row mb-0">
            <label for="sharingWith" class="col-md-12 col-form-label text-md-left">Share with (enter email address)</label>

            <div class="col-8">
              <input id="sharingWith" v-model="form.sharingWith.email" :class="{ 'is-invalid': errors.sharingWith.email }" type="text" class="form-control">
              <span v-if="errors.sharingWith.email" class="invalid-feedback">
                <div v-for="(error, index) in errors.sharingWith.email" :key="index"><strong>{{ error }}</strong></div>
              </span>
            </div>
            <div class="col-4">
              <button type="submit" class="btn btn-primary mt-0" @click.prevent="submitShareWith()">
                <span v-if="this.$loading.isLoading('ledger-sharing-with')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Add
              </button>
            </div>
            <div class="col-md-12">
              <span class="feedback"><i class="pe pe-info" aria-hidden="true"/><span class="inline-text">One small detail though: that someone must also have an Expense Guide account, and have their email address in our database — because, well... <a href="https://eugdpr.org/" target="_blank">GDPR!</a></span></span>
            </div>
          </div>

          <ul class="list-group list-group-flush mt-4">
            <li v-for="(item, index) in state.ledger.selectedLedger.users" v-if="state.account.me && state.ledger.selectedLedger.owner_id != item.id" :key="index" class="list-group-item">
              {{ item.name }} (<i>{{ item.email }}</i>)
              <a v-if="state.account.me.id === state.ledger.selectedLedger.owner_id || state.account.me.id === item.id" href="" class="share-remove-icon" @click.prevent="submitUnshareWith(item.id)"><i class="pe pe-trash-o" aria-hidden="true"/></a>
            </li>
          </ul>
        </b-tab>
        <b-tab v-if="state.ledger.selectedLedger.name && state.account.me && state.account.me.id === state.ledger.selectedLedger.owner_id" title="Remove">
          <br>
          <div class="row">
            <div class="col-8">
              <div v-if="error.destroy" class="alert alert-danger">{{ error.destroy }}</div>
              <div v-if="message.destroy" class="alert alert-success">{{ message.destroy }}</div>
            </div>
          </div>
          <div class="form-group row mb-0">
            <label for="password" class="col-md-12 col-form-label text-md-left">Password</label>

            <div class="col-8">
              <input id="password" v-model="form.destroy.password" :class="{ 'is-invalid': errors.destroy.password }" type="password" class="form-control" required>
              <span v-if="errors.destroy.password" class="invalid-feedback">
                <div v-for="(error, index) in errors.destroy.password" :key="index"><strong>{{ error }}</strong></div>
              </span>
            </div>
            <div class="col-4">
              <button type="submit" class="btn btn-danger" @click.prevent="submitDestroy()">
                <span v-if="this.$loading.isLoading('destroying-ledger')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Destroy
              </button>
            </div>
            <div class="col-md-12">
              <span class="feedback"><i class="pe pe-info" aria-hidden="true"/><span class="inline-text">To destroy the ledger please enter your account password</span></span>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    ledgerData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      error: {
        details: '',
        sharingWith: '',
        destroy: ''
      },
      errors: {
        details: {},
        sharingWith: {},
        destroy: {}
      },
      message: {
        details: '',
        sharingWith: '',
        destroy: ''
      },
      form: {
        details: {},
        sharingWith: {},
        destroy: {}
      }
    }
  },
  computed: {
    ...mapState({
      state: state => state
    }),
    ledgerId () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapMutations([
      'SET_MODAL_OPEN',
      'SET_MODAL_CLOSED'
    ]),
    ...mapActions([
      'getLedgers',
      'updateLedger',
      'shareLedgerWith',
      'unshareLedgerWith',
      'destroyLedger'
    ]),
    showLedgerSettings () {
      let data = JSON.parse(JSON.stringify(this.ledgerData))
      this.form.details = {
        id: data.id,
        name: data.name,
        currency: data.currency,
        show_statistics_on_dashboard: data.show_statistics_on_dashboard
      }
      this.$refs.ledgerSettings.show()
      this.SET_MODAL_OPEN()
    },
    hideLedgerSettings () {
      this.$refs.ledgerSettings.hide()

      this.message = { details: '', sharingWith: '', destroy: '' }
      this.errors = { details: {}, sharingWith: {}, destroy: {} }
      this.error = { details: '', sharingWith: '', destroy: '' }

      this.SET_MODAL_CLOSED()
    },
    submitDetails () {
      this.$loading.startLoading('ledger-updating')
      this.errors.details = {}
      this.updateLedger(this.form.details)
        .then((data) => {
          this.$loading.endLoading('ledger-updating')
          this.error.details = ''
          this.errors.details = {}
          this.message.details = data.message
        })
        .catch((data) => {
          this.message.details = ''
          this.error.details = data.message
          this.errors.details = data.errors || {}
          this.$loading.endLoading('ledger-updating')
        })
    },
    submitShareWith () {
      this.$loading.startLoading('ledger-sharing-with')
      this.errors.sharingWith = {}
      this.shareLedgerWith({ ledgerId: this.ledgerId, shareWith: this.form.sharingWith })
        .then((data) => {
          this.$loading.endLoading('ledger-sharing-with')
          this.error.sharingWith = ''
          this.errors.sharingWith = {}
          this.message.sharingWith = data.message
        })
        .catch((data) => {
          this.message.sharingWith = ''
          this.error.sharingWith = data.message
          this.errors.sharingWith = data.errors || {}
          this.$loading.endLoading('ledger-sharing-with')
        })
    },
    submitUnshareWith (userId) {
      let self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        animation: false
      }).then((result) => {
        if (result.value) {
          self.unshareLedgerWith({ ledgerId: self.ledgerId, userId: userId })
            .then((data) => {
              self.error.sharingWith = ''
              self.errors.sharingWith = {}
              self.message.sharingWith = data.message
              if (userId === self.state.account.me.id) {
                self.$router.push({ name: 'Dashboard' })
                self.getLedgers()
              }
            })
            .catch((data) => {
              self.message.sharingWith = ''
              self.error.sharingWith = data.message
              self.errors.sharingWith = data.errors || {}
            })
        }
      })
    },
    submitDestroy () {
      let self = this
      this.$swal({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        animation: false
      }).then((result) => {
        if (result.value) {
          self.$loading.startLoading('destroying-ledger')
          self.destroyLedger({ ledgerId: self.ledgerId, password: self.form.destroy.password })
            .then((data) => {
              self.error.destroy = ''
              self.errors.destroy = {}
              self.message.destroy = data.message
              self.$loading.endLoading('destroying-ledger')
              self.$router.push({ name: 'Dashboard' })
            })
            .catch((data) => {
              self.message.destroy = ''
              self.error.destroy = data.message
              self.errors.destroy = data.errors || {}
              self.$loading.endLoading('destroying-ledger')
            })
        }
      })
    }
  }
}
</script>

<style>
  .ledgerShowOnDashboard .custom-control-label{
    padding-top: 12px;
  }
</style>
